<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Troncos</div>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :tronco="tronco" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog>  
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataTroncos"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/troncos/criar"
              target="_blank"
              @click="handleGoToNewTronco"
            >
              Criar Tronco
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialog(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Uso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/troncos/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Troncos: {{ qtdTroncos }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import troncosStore from '../_store'
import TroncosHttpService from '../_services/TroncosHttpService'
import Dialog from '../_components/Dialog.vue'

export default {
  components: { ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Tronco',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Tipo',
        value: 'tipo',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataTroncos: [],
    dialog: false,
    tronco: {},
  }),

  computed: {
    ...mapGetters('troncosHomeModulePABXStore', ['getTroncos', 'getTroncoUse']),

    numberOfPages() {
      return Math.ceil(this.dataTroncos.length / this.itemsPerPage)
    },
    qtdTroncos() {
      return this.dataTroncos.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'troncosHomeModulePABXStore', troncosStore)

    await this.listarTroncos()
    this.dataTroncos = [...this.getTroncos]

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('troncosHomeModulePABXStore', ['listarTroncos', 'listarTroncoUse']),

    handleGoToNewTronco(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewTronco = this.$router.resolve({ name: 'CriarTroncos' })
        window.open(goToNewTronco.href, '_blank')
      } else {
        this.$router.push({ name: 'CriarTroncos' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`troncos/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`troncos/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`troncos/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`troncos/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o tronco "${item.description}"?`)
      if (resultado) {
        try {
          await TroncosHttpService.deleteTronco(item._id)
          this.dataTroncos = this.dataTroncos.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
    async openDialog(tronco) {
      await this.listarTroncoUse(tronco._id)
      this.tronco = tronco
      this.dialog = true
    
    }
  },
}
</script>
